<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('triggers') }} -> {{ $t('list-triggers') }}
    </h1>
    <div class="main__body">
      <p class="gray-about">{{ $t('create-trigger-about-1') }}</p>
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">{{ $t('name-trigger') }}</th>
          <th scope="col">{{ $t('key') }} {{ $t('for') }} CRM</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in triggers" v-bind:key="item.id">
          <th scope="row">
            {{ index + 1}}
          </th>
          <td>{{ item.name }}</td>
          <td>{{ item.token }}</td>
        </tr>
        </tbody>
      </table>
      <div class="form-row mt-1">
        <router-link class="btn btn-primary" to="/create-trigger">{{ $t('create-trigger') }}</router-link>
      </div>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'list-trigger',
  data: function(){
    return{
      triggers: [],
      isLoading: false,
      fullPage: true,
    }
  },
  created: function(){
    this.getTriggers();
  },
  methods: {
    getTriggers: function(){
      this.isLoading = true;
      axios.post('getTriggers').then(response => {
        var status = response.data.status;
        if(status){
          this.triggers = response.data.triggers;
          this.isLoading = false;
        }
      });
    },
  },
  components: {
    loading
  }
}
</script>